import client from 'FrontendJsAssets/common/client'
import { updateLazy } from 'Functions/lazy';
import { buildStars } from 'Functions/rating';
import LazyLoad from 'vanilla-lazyload';

function getSeenProducts() {
    let currentProductId
    let seenProducts

    if (document.querySelector('.js-product-detail')) {
        currentProductId = document.querySelector('.js-product-detail').dataset.productId
    }

    try {
        seenProducts = JSON.parse(localStorage.getItem('seenProducts'))
    } catch {
        seenProducts = []
    }

    if (!Array.isArray(seenProducts)) {
        seenProducts = []
    }

    if (currentProductId && seenProducts.includes(currentProductId)) {
        seenProducts.splice(seenProducts.indexOf(currentProductId), 1)
    }

    return seenProducts
}

if (document.querySelector('.js-product-detail-seen')) {
    const seenProducts = getSeenProducts()

    if (!seenProducts.length) {
        document.querySelector('.js-product-detail-seen').remove()
    }
}

if (document.querySelector('.js-product-detail')) {
    const productId = document.querySelector('.js-product-detail').dataset.productId
    let seenProducts = getSeenProducts()

    seenProducts.unshift(productId)
    seenProducts = seenProducts.slice(0, 18)

    window.localStorage.setItem('seenProducts', JSON.stringify(seenProducts))
}

const seenLazyLoad = new LazyLoad({
    threshold: 125,
    elements_selector: '.js-product-detail-seen',
    callback_enter: (seenHolder) => {
        const seenProducts = getSeenProducts()

        if (!seenProducts.length) {
            return
        }

        seenHolder.classList.add('is-loading')
        seenHolder.classList.remove('js-product-detail-seen')
        seenLazyLoad.update()

        client.post('/custom-seen-products', {
            product_ids: seenProducts.splice(0, 18)
        })
        .then((response) => {
            seenHolder.innerHTML = response.data

            buildStars()
            updateLazy()
            window.initializeSpinners()
        })
        .catch((error) => {
            console.error(error)
            seenHolder.remove()
        })
        .finally(() => {
            seenHolder.classList.remove('is-loading')
        })
    }
})